import interfaceApi from '@/api/admin/interfaceApi'
import ButtonField from '@/components/form-control/ButtonField'
import { RefreshIcon } from '@/components/icons'
import ArrowDoubleLeftIcon from '@/components/icons/ArrowDoubleLeftIcon'
import AttentionIcon from '@/components/icons/AttentionIcon'
import { queryKeys } from '@/constant/common'
import useSearchInterfaceId from '@/features/admin/hooks/interface/useSearchInterfaceId'
import { useAuthContext } from '@/features/auth/context'
import { NotifyService } from '@/helpers'
import { useDateTime } from '@/hooks/useDateTime'
import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import classes from './styles.module.scss'

interface ModalProps {
  subInterfaceId?: number|null
}

const StatusInterface = (props: ModalProps) => {
  let { interfaceId } = useAuthContext()
  const queryClient = useQueryClient()
  interfaceId = props.subInterfaceId || interfaceId

  const { formatDateTimeWithoutInterfaceId } = useDateTime()
  const [showLoading, setShowLoading] = useState(false)
  const [expandError, setExpandError] = useState(true)

  const { data } = useSearchInterfaceId(interfaceId?.toString())

  const handleClick = async () => {
    setShowLoading(true)
    await interfaceApi.getAutoSync()
    queryClient
      .invalidateQueries([queryKeys.interface])
      .then((res) => {
        NotifyService.success('Resync Interface Success')
      })
      .catch((e) => NotifyService.error(e))
    setShowLoading(false)
  }

  const { setStatusInterfaceId } = useAuthContext()

  useEffect(() => {
    if (expandError) {
      setStatusInterfaceId(expandError.toString())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandError])

  const handleExpandError = () => {
    setExpandError(false)
    setStatusInterfaceId('false')
  }

  const handleExpand = () => {
    setExpandError(true)
    setStatusInterfaceId('true')
  }

  return (
    <>
      {data && data.state === 'Offline' && (
        <Stack onClick={(event) => event.stopPropagation()}>
          {expandError ? (
            <Stack className={classes.container}>
              <Stack direction="row" spacing={1}>
                <AttentionIcon sx={{ color: 'red' }} />
                <Typography className={classes.txtControllerOff}>
                  Controller Offline
                </Typography>
              </Stack>
              <Typography className={classes.txtName}>{data?.name}</Typography>
              <Stack direction="row" spacing={1} mt="15px">
                <Typography className={classes.txtLastUpdate}>
                  Last update
                </Typography>
                <Typography className={classes.txtLastUpdate}>
                  {formatDateTimeWithoutInterfaceId(
                    data?.updatedAt.concat('Z'),
                    'full',
                    data?.timeZone,
                  ) || '-'}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" mt="30px">
                <Button variant="secondary" onClick={handleExpandError}>
                  Hide
                </Button>
                {showLoading ? (
                  <ButtonField
                    startIcon={
                      <CircularProgress sx={{ color: '#fff' }} size={14} />
                    }
                    style={{
                      height: '32px',
                      minWidth: '89px',
                      borderRadius: '5px',
                    }}
                    sx={{
                      backgroundColor: '#004744 !important',
                      color: '#fff',
                      height: '32px !important',
                      '&:hover': {
                        backgroundColor: '#004744 !important',
                        color: '#fff',
                      },
                    }}
                    name="Syncing..."
                  />
                ) : (
                  <ButtonField
                    startIcon={<RefreshIcon />}
                    style={{
                      height: '32px',
                      minWidth: '89px',
                      borderRadius: '5px',
                    }}
                    sx={{
                      backgroundColor: '#004744 !important',
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: '#004744 !important',
                        color: '#fff',
                      },
                    }}
                    name="Resync"
                    onClick={handleClick}
                  />
                )}
              </Stack>
            </Stack>
          ) : (
            <Stack className={classes.containerOffline}>
              <Stack direction="row" spacing={1} p="20px">
                <AttentionIcon sx={{ color: 'red' }} />
                <Typography className={classes.txtControllerOff}>
                  Controller Offline
                </Typography>
              </Stack>
              <Button
                className={classes.btnShow}
                onClick={handleExpand}
                startIcon={<ArrowDoubleLeftIcon />}
              >
                Show
              </Button>
            </Stack>
          )}
        </Stack>
      )}
    </>
  )
}

export default StatusInterface
